import { Component, ErrorInfo, PropsWithChildren } from "react";

import { ErrorView } from "@/components/_molecules/error-view";
import { pushFaroError } from "@/services/faro.service";

interface AppErrorBoundaryState {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    pushFaroError(error, {
      componentStack: errorInfo.componentStack ?? "unknown",
      source: "react-error-boundary",
    });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorView />;
    }
    return this.props.children;
  }
}
